import { Menu, Layout, Drawer, DrawerProps, Button } from 'antd';
import {
  UserOutlined,
  LaptopOutlined,
  DiffOutlined,
  HomeOutlined,
  TableOutlined,
  PlusCircleOutlined,
  FallOutlined,
  RiseOutlined,
  MenuOutlined,
  FileTextOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';
import { Link, useHistory, useLocation } from 'react-router-dom';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { useState } from 'react';
import { useMemo } from 'react';
import { SiderProps } from 'antd/lib/layout';

const { Sider } = Layout;
const { SubMenu } = Menu;

export default function DefaultLayoutSidebar() {
  const APP_BASE_URL = process.env.REACT_APP_BASE_URL;
  const { lg } = useBreakpoint();

  const history = useHistory();
  const location = useLocation();

  const [show, setShow] = useState(false);

  const SidebarWrapper: React.FC = useMemo(() => (lg ? Sider : Drawer), [lg]);

  const siderProps = useMemo((): SiderProps => {
    return {
      width: 200,
      className: 'site-layout-background no-print',
    };
  }, []);

  const drawerProps = useMemo((): DrawerProps => {
    return {
      visible: show,
      closable: true,
      title: <></>,
      headerStyle: {
        height: 64,
      },
      bodyStyle: {
        padding: 0,
      },
      onClose() {
        setShow(false);
      },
      placement: 'left',
    };
  }, [show]);

  const sidebarProps = useMemo(() => {
    return lg ? siderProps : drawerProps;
  }, [lg, siderProps, drawerProps]);

  function atualizarHistorico(caminho: string) {
    history.push(caminho);
  }

  return (
    <>
      {!lg && (
        <Button
          icon={<MenuOutlined />}
          onClick={() => setShow(true)}
          type={'text'}
          style={{ position: 'fixed', top: 0, left: 0, height: 64, zIndex: 99 }}
        />
      )}
      <SidebarWrapper {...sidebarProps}>
        <Menu
          mode='inline'
          defaultSelectedKeys={[location.pathname]}
          defaultOpenKeys={[location.pathname.split('/')[1]]}
          style={{ height: '100%', borderRight: 0 }}
        >
          <Menu.Item
            key={'/'}
            icon={<HomeOutlined />}
            onClick={function (event) {
              setShow(false);
            }}
          >
            <Link to={'/'}>Home</Link>
          </Menu.Item>
          <SubMenu key='pedidos' icon={<FileTextOutlined />} title='Pedidos'>
            <Menu.Item
              key='/pedidos'
              onClick={function (event) {
                atualizarHistorico('/pedidos');
                setShow(false);
              }}
              icon={<FileSearchOutlined />}
            >
              <Link to={'/pedidos'}>Consulta</Link>
            </Menu.Item>
          </SubMenu>
          <SubMenu key='cuponsfiscais' icon={<FileTextOutlined />} title='Cupons fiscais'>
            <Menu.Item
              key='/cuponsfiscais'
              onClick={function (event) {
                atualizarHistorico('/cuponsfiscais');
                setShow(false);
              }}
              icon={<FileSearchOutlined />}
            >
              <Link to={'/cuponsfiscais'}>Consulta</Link>
            </Menu.Item>
          </SubMenu>
        </Menu>
      </SidebarWrapper>
    </>
  );
}
